// FioNova primitives: pill buttons, eyebrow label, choice chip.

export const PrimaryButton = ({ children, className = "", ...props }) => (
  <button
    type={props.type || "button"}
    {...props}
    className={`flex w-full items-center justify-center gap-2 rounded-full bg-primary px-6 py-4 text-base font-semibold text-primary-foreground transition-all hover:bg-primary/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-45 ${className}`}
  >
    {children}
  </button>
);

export const SecondaryButton = ({ children, className = "", ...props }) => (
  <button
    type={props.type || "button"}
    {...props}
    className={`flex w-full items-center justify-center gap-2 rounded-full bg-card px-6 py-4 text-base font-semibold text-foreground ring-1 ring-border transition-all hover:bg-black/[0.02] focus:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className}`}
  >
    {children}
  </button>
);

export const TextLink = ({ children, className = "", ...props }) => (
  <button
    type="button"
    {...props}
    className={`text-base font-medium text-muted-foreground transition-colors hover:text-foreground focus:outline-none focus-visible:underline ${className}`}
  >
    {children}
  </button>
);

export const Eyebrow = ({ children, className = "", style }) => (
  <p className={`eyebrow text-xs text-primary ${className}`} style={style}>{children}</p>
);

export const ChoiceChip = ({ selected, children, testId, ...props }) => (
  <button
    type="button"
    data-testid={testId}
    aria-pressed={!!selected}
    {...props}
    className={`rounded-full px-5 py-3 text-sm font-medium transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
      selected
        ? "bg-primary text-primary-foreground shadow-[0_2px_10px_rgba(0,0,0,0.06)]"
        : "bg-card text-foreground ring-1 ring-border hover:ring-primary/40"
    }`}
  >
    {children}
  </button>
);

export const InputField = ({ label, testId, className = "", ...props }) => (
  <label className="block">
    {label && <span className="mb-2 block text-sm font-medium text-foreground/80">{label}</span>}
    <input
      data-testid={testId}
      {...props}
      className={`w-full rounded-2xl bg-card px-4 py-4 text-base text-foreground ring-1 ring-border transition-colors placeholder:text-muted-foreground/70 focus:outline-none focus:ring-2 focus:ring-primary ${className}`}
    />
  </label>
);
